export default __webpack_public_path__ + "static/media/wTop_2_p1.311f98e5.jpeg";